/**
 * Payment Card Skeleton Loader Component
 * Displays skeleton loader while payment cards are loading
 * Requirements: 15.1, 15.2
 */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-payment-card-skeleton',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule
  ],
  templateUrl: './payment-card-skeleton.component.html',
  styleUrls: ['./payment-card-skeleton.component.scss']
})
export class PaymentCardSkeletonComponent {}
